import React from 'react';
import Button from 'common/components/Button';
import { connect } from 'react-redux';

import {
  saveCartRequest,
  openCartForDesktop,
  changeVariantQuantity,
} from '../actions';

const offeringToLineItem = offering => ({
  sku: offering.variantSku,
  quantity: 1,
  offeringId: offering.id,
});

const mapDispatchToProps = (
  dispatch,
  { onClick, offerings, shouldAutoCloseCart = true }
) => ({
  onClick: () => {
    // It may seem redundant to change quantities of pending line items if
    // we're just about to save the cart and wipe them. The reason this is done
    // is so we can show the "(X) items added to your cart" message when in
    // mobile view.
    for (const offering of offerings) {
      const variant = { sku: offering.variantSku };
      dispatch(changeVariantQuantity(variant, offering.id, 1));
    }
    dispatch(saveCartRequest(offerings.map(offeringToLineItem), true));
    dispatch(openCartForDesktop(shouldAutoCloseCart));
    onClick && onClick();
  },
});

const AddMultipleOfferingsToCartButton = props => (
  <Button onClick={props.onClick} className={props.className}>
    {props.children}
  </Button>
);

export default connect(
  null,
  mapDispatchToProps
)(AddMultipleOfferingsToCartButton);
